import { render, staticRenderFns } from "./CustomReport.vue?vue&type=template&id=56fede26&scoped=true&"
import script from "./CustomReport.vue?vue&type=script&lang=js&"
export * from "./CustomReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomReport.vue?vue&type=style&index=0&id=56fede26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fede26",
  null
  
)

export default component.exports